import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface BookingManagementProtectedRouteProps {
  children: React.ReactNode;
}

const BookingManagementProtectedRoute: React.FC<BookingManagementProtectedRouteProps> = ({ children }) => {
  const { currentUser, loading, userRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (!currentUser) {
    // Redirect to login with the return path
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Only allow access if user is admin or owner
  if (userRole !== 'admin' && userRole !== 'owner') {
    // Redirect to home page if user doesn't have required role
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default BookingManagementProtectedRoute;
